'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxConnect = require('redux-connect');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);

var _articles = require('../../redux/modules/articles');

var _SingleArticlePage = require('./SingleArticlePage.scss');var _SingleArticlePage2 = _interopRequireDefault(_SingleArticlePage);
var _index = require('../index');
var _components = require('../../components');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Redux
// Styles
var SingleArticlePage = function (_Component) {_inherits(SingleArticlePage, _Component);function SingleArticlePage() {var _temp, _this, _ret;_classCallCheck(this, SingleArticlePage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderSEOData = function () {var _this$props = _this.props,article = _this$props.article,route = _this$props.route,locale = _this$props.locale;
      var metaTitle = article.title + ' | \u202BOnMap';
      var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);
      return (
        _react2.default.createElement(_reactHelmet2.default, { titleTemplate: '' + _this.props.translate('title', 'titleTemplate') },
          _react2.default.createElement('title', null, article.title),
          _react2.default.createElement('meta', { property: 'title', content: metaTitle }),
          _react2.default.createElement('meta', { property: 'og:title', content: metaTitle }),
          _react2.default.createElement('meta', { property: 'og:image', content: article.image.thumbnail }),
          _react2.default.createElement('meta', { name: 'description', content: article.description }),
          _react2.default.createElement('meta', { property: 'og:description', content: article.description }),
          _react2.default.createElement('meta', { property: 'og:url', content: '' + _constants.shareUrl + route }),
          _react2.default.createElement('link', { rel: 'canonical', href: '' + _constants.shareUrl + route }),
          multiLanguage && multiLanguage.map(function (item) {return (
              _react2.default.createElement('link', { key: item.hrefLang + '-key', rel: item.rel, hrefLang: item.hrefLang, href: item.href }));}),
          _this.props.locale === 'fr' && _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })));


    }, _temp), _possibleConstructorReturn(_this, _ret);}SingleArticlePage.prototype.

  render = function render() {var _props =
    this.props,article = _props.article,error = _props.error,locale = _props.locale,isMobile = _props.isMobile,translate = _props.translate;

    var hasError = !article && error && error.status === 404;
    var wrongLang = article && article.lang !== locale && locale !== 'fr';

    if (hasError || wrongLang) {
      return _react2.default.createElement(_index.NotFoundPage, null);
    }

    var sharingData = {
      sharingUrl: (0, _makeSharingUrl2.default)('/articles/' + article.id, locale),
      sharingTitle: article.title,
      sharingDescription: article.description };


    if (article) {
      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_SingleArticlePage2.default.articleWrapper, 'pageHeight') },
          this.renderSEOData(),
          _react2.default.createElement('div', { className: _SingleArticlePage2.default.topPart },
            _react2.default.createElement('h1', { className: _SingleArticlePage2.default.title }, article.title),
            _react2.default.createElement('h2', { className: _SingleArticlePage2.default.description }, article.description),
            _react2.default.createElement('div', { className: _SingleArticlePage2.default.creationBlock },
              _react2.default.createElement('div', { className: _SingleArticlePage2.default.shareBlock },
                _react2.default.createElement(_components.ShareArticleButtons, {
                  sharingData: sharingData,
                  isMobile: isMobile,
                  locale: locale,
                  translate: translate,
                  className: 'articleSocialIcons',
                  isHideShareTitle: true })),


              _react2.default.createElement('div', { className: _SingleArticlePage2.default.authorBlock },
                article.author, ' \u2022 ', (0, _moment2.default)(article.created_at).format('DD/MM/YYYY')))),



          _react2.default.createElement('div', { className: _SingleArticlePage2.default.articleBody, dangerouslySetInnerHTML: { __html: article.article_body } })));


    }return _react2.default.createElement('div', { className: 'pageHeight' });
  };return SingleArticlePage;}(_react.Component);


SingleArticlePage.propTypes = {
  article: _propTypes2.default.object,
  error: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  route: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool };


var asyncData = [{
  key: 'fetchArticle',
  promise: function promise(_ref) {var id = _ref.params.id,_ref$store = _ref.store,dispatch = _ref$store.dispatch,getState = _ref$store.getState;var
    locale = getState().lang.locale;
    return dispatch((0, _articles.getArticleById)({ id: id, lang: locale }));
  } }];


var mapStateToProps = function mapStateToProps(state) {return {
    article: state.articles.article,
    error: state.articles.error,
    locale: state.lang.locale,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static') };};


var mapDispatchToProps = { getArticleById: _articles.getArticleById };exports.default =

(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
SingleArticlePage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/SingleArticlePage/SingleArticlePage.js
// module id = 3112
// module chunks = 0